import script from "./politicasGarantiaGST.vue?vue&type=script&setup=true&lang=js"
export * from "./politicasGarantiaGST.vue?vue&type=script&setup=true&lang=js"

import "./politicasGarantiaGST.vue?vue&type=style&index=0&id=7aa53f18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7aa53f18"]])

export default __exports__